import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login-failed',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  template: `
    <div class="login-failed">
      <h1>Error al iniciar sesión</h1>
      <p>No se pudo completar el inicio de sesión con Microsoft. Inténtalo de nuevo.</p>
      <a routerLink="/" class="link">Volver al inicio</a>
      <button type="button" (click)="retry()">Reintentar login</button>
    </div>
  `,
  styles: [
    `
      .login-failed {
        padding: 2rem;
        text-align: center;
      }
      .link {
        display: inline-block;
        margin-right: 1rem;
      }
    `,
  ],
})
export class LoginFailedComponent {
  private readonly auth = inject(AuthService);

  retry(): void {
    this.auth.login();
  }
}
